import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=0479a848&"
import script from "./NotificationBell.vue?vue&type=script&lang=js&"
export * from "./NotificationBell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0479a848')) {
      api.createRecord('0479a848', component.options)
    } else {
      api.reload('0479a848', component.options)
    }
    module.hot.accept("./NotificationBell.vue?vue&type=template&id=0479a848&", function () {
      api.rerender('0479a848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/NotificationBell.vue"
export default component.exports